import type { PropsWithChildren } from 'react';

import { AuthProvider } from 'watchtower-ui/contexts/AuthContext';
import Country from 'watchtower-ui/contexts/Country';
import Currency from 'watchtower-ui/contexts/Currency';
import { FeatureFlagContextManager } from 'watchtower-ui/contexts/FeatureFlagContext';

const RootProvider = ({ children }: PropsWithChildren) => (
  <FeatureFlagContextManager>
    <AuthProvider>
      <Country.ContextManager>
        <Currency.ContextManager>{children}</Currency.ContextManager>
      </Country.ContextManager>
    </AuthProvider>
  </FeatureFlagContextManager>
);

export default RootProvider;
